module.exports = __webpack_public_path__ + "static/media/blackBrush_smallInHeightv3.45718cb6.png";